import { jsx as _jsx } from "react/jsx-runtime";
import { FieldEditor } from './FieldEditor.js';
import { ComponentSync } from '../core/ComponentSync.js';
import { StorageKey } from '../modules/ModuleFE_LocalStorage.js';
export class FieldEditorClick extends ComponentSync {
    createStorageKey() {
        return new StorageKey(`editable-label-controller-${this.props.id}`);
    }
    deriveStateFromProps(nextProps) {
        return {
            storageKey: this.createStorageKey(),
            isEditing: false,
        };
    }
    componentDidUpdate(prevProps, prevState) {
        let storageKey = prevState.storageKey;
        if (prevProps.id !== this.props.id) {
            storageKey = this.createStorageKey();
            this.setState({ storageKey: storageKey });
        }
        const prevValue = storageKey.get();
        if (!prevValue)
            storageKey.set(this.props.value || '');
    }
    handleSave = () => {
        this.props.onAccept(this.state.storageKey.get() ?? '');
        this.endEdit();
    };
    startEdit = () => {
        if (this.state.isEditing)
            return;
        addEventListener('keydown', this.keyPressed);
        this.state.storageKey.set(this.props.value || '');
        this.setState({ isEditing: true });
    };
    endEdit = () => {
        removeEventListener('keydown', this.keyPressed);
        this.logDebug('endEdit');
        this.state.storageKey.delete();
        this.setState({ isEditing: false });
    };
    keyPressed = (e) => {
        if (e.code === 'Escape')
            this.endEdit();
    };
    render() {
        return (_jsx("div", { style: { width: '100%' }, onClick: this.props.clicks === 1 ? this.startEdit : undefined, onDoubleClick: this.props.clicks === undefined || this.props.clicks === 2 ? this.startEdit : undefined, onBlur: () => this.handleSave(), ...this.props.labelProps, children: _jsx(FieldEditor, { id: this.props.id, type: this.props.type, editorType: this.props.editorType, isEditing: this.state.isEditing, inputProps: this.props.inputProps, labelProps: this.props.labelProps, onCancel: this.endEdit, onAccept: this.handleSave, storageKey: this.state.storageKey, value: this.props.value }) }));
    }
}
//# sourceMappingURL=FieldEditorClick.js.map